// src/pages/SwitchClientsPage.jsx

import React, { useState } from "react";
import { Box } from "@mui/material";
import PageHeader from "../components/ui/PageHeader";
import SwitchClientList from "../components/switchClients/SwitchClientList";

const SwitchClientsPage = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey((k) => k + 1);
  };

  return (
    <Box>
      <PageHeader
        title="Clientes con cambio de comercializadora"
      />
      <SwitchClientList key={refreshKey} onRefresh={handleRefresh} />
    </Box>
  );
};

export default SwitchClientsPage;